import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ReportTemplatesComponent } from './report-templates.component';
import { ReportTemplateDetailComponent } from './report-template-detail.component';

/** Keeps the template table mounted while a routed template page opens beside it, like Campaigns. */
@Component({
  selector: 'app-report-templates-workspace',
  template: `<app-workspace-master-detail [detailOpen]="detailOpen">
    <app-report-templates workspace-master></app-report-templates>
    <div workspace-detail class="workspace-page--full"><router-outlet (activate)="activated($event)" (deactivate)="deactivated()"></router-outlet></div>
  </app-workspace-master-detail>`,
  host: { class: 'workspace-master-detail-page' },
})
export class ReportTemplatesWorkspaceComponent implements OnDestroy {
  @ViewChild(ReportTemplatesComponent) collection?: ReportTemplatesComponent;
  private detailChanges?: Subscription;
  constructor(private readonly route: ActivatedRoute) {}
  get detailOpen(): boolean { return this.route.firstChild !== null; }
  activated(component: unknown): void {
    this.deactivated();
    if (component instanceof ReportTemplateDetailComponent) {
      this.detailChanges = component.saved.subscribe(() => this.collection?.refresh());
    }
  }
  deactivated(): void { this.detailChanges?.unsubscribe(); }
  ngOnDestroy(): void { this.deactivated(); }
}
